import React,{useState} from "react";
import { Link } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { BsSunFill } from "react-icons/bs";
import { RiMoonFill } from "react-icons/ri";
import useAuth from "../../Hooks/useAuth";

const SideBar = () => {
  const [theme,setTheme] = useState(false);
  const { sideBar, setSideBar } = useAuth();
  const changeTheme =()=>{
    setTheme(!theme);
  }
  return (
    <aside className="sidebar">
      <div className={`sidebar-overlay ${sideBar ? "showOverlay" : ""}`}  onClick={() => setSideBar(false)}></div>
      <div className={`sideBar-content ${sideBar ? "showSidebar" : ""}`}>
        <div className="sideBar-top">
          <nav className="sideBar-nav">
            <Link
              to={"/explore"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
              Explore
            </Link>

            <Link
              to={"/ranking"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
              Ranking
            </Link>

            <Link
              to={"/popular"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
              Popular
            </Link>

            <Link
              to={"/ourblog"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
             Blog
            </Link>

            <Link
              to={"/uploadwork"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
              Upload work
            </Link>

            <Link
              to={"/faq"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
             Faqs
            </Link>

            <Link
              to={"/contact"}
              className="sideBar-nav-link"
              onClick={() => {
                setSideBar(false);
              }}
            >
              Contact
            </Link>

            <Link
                  to={"/signin"}
                  className="sideBar-nav-link"
                  onClick={() => {
                    setSideBar(false);
                  }}
                >
                  Sing In
            </Link>
          </nav>
          <div className="sideBar-action">
            <div className="theme-switch">
              <div
                className="switch-left"
                onClick={() => {
                  changeTheme();
                }}
              >
                <BsSunFill />
              </div>
              <div
                className="switch-right"
                onClick={() => {
                  changeTheme();
                }}
              >
                <RiMoonFill />
              </div>
              <span
                className={`${theme ? "toggleLeft" : "toggleRight"}`}
              ></span>
            </div>
            <button
              className="sideBar-closer"
              onClick={() => {
                setSideBar(false);
              }}
            >
              <ImCross />
            </button>
          </div>
        </div>
        <div className="sidebar-bottom">
        <Link to={"/connectwallet"} className="sidebar-wallet" onClick={() => { setSideBar(false);}}>
          Connect Wallet
        </Link>
        </div>
      </div>
    </aside>
  );
};

export default SideBar;
